import Component, { mixins } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

import WithRender from './FicheRepondantAvailableCasSpecial.html'

import {
  MMessage,
  MMessageState
} from '@ulaval/modul-components'

import FicheRepondantAvailableCasSpecialRow from './FicheRepondantAvailableCasSpecialRow'
import { ICasSpecialRepondant } from '../CasSpecialRepondant.model'

@WithRender
@Component({
  components: {
    FicheRepondantAvailableCasSpecialRow,
    MMessage
  }
})
export default class FicheRepondantAvailableCasSpecial extends mixins() {
  private readonly MMessageState: object = MMessageState
  
  @Prop({ required: true })
  private casSpeciaux!: Array<ICasSpecialRepondant>
}
